import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getSupportedVariant, isSupportedVariant } from '@ubnt/wifi-calculator/utils';
import type { AppThunk } from 'app/store';
import {
  devicesDeviceInstanceSelector,
  devicesDeviceUpdate,
  devicesDeviceVariantSelector,
} from 'modules/devices/slice';
import {
  LINK_ID,
  linksLinkApIdSelector,
  linksLinkClientIdSelector,
  linksLinkIsMeshSelector,
} from 'modules/links/slice';
import { get5GhzVariants, getMeshVariant } from 'modules/devices/utils';
import { settingsCountrySelector } from 'modules/settings/slice';

interface ActiveElementState {
  linkId: string;
}

const initialState: ActiveElementState = {
  linkId: LINK_ID,
};

const activeElementSlice = createSlice({
  name: 'activeElement',
  initialState,
  reducers: {
    activeElementSet(state, action: PayloadAction<{ linkId: string }>) {
      state.linkId = action.payload.linkId;
    },
  },
});

export const { activeElementSet } = activeElementSlice.actions;

export const activeElementActivateLink: (linkId: string) => AppThunk = (linkId) => (dispatch, getState) => {
  const state = getState();
  const linkIsMesh = linksLinkIsMeshSelector(state, linkId);
  const apId = linksLinkApIdSelector(state, linkId);
  const variant = devicesDeviceVariantSelector(state, apId);
  const apInstance = devicesDeviceInstanceSelector(state, apId);
  const meshVariants = get5GhzVariants(apInstance.variants);

  // TODO(mantas.grabauskas@ui.com): should check device capabilities in case device can mesh over other radios too
  if (linkIsMesh && variant != null && !meshVariants?.includes(variant)) {
    dispatch(devicesDeviceUpdate({ id: apId, changes: { variant: getMeshVariant(apInstance.variants) } }));
  } else if (variant != null) {
    const clientId = linksLinkClientIdSelector(state, linkId);
    const clientDeviceInstance = devicesDeviceInstanceSelector(state, clientId);

    if (!isSupportedVariant(clientDeviceInstance.variants, variant)) {
      const newVariant = getSupportedVariant(apInstance, clientDeviceInstance, settingsCountrySelector(state));
      dispatch(devicesDeviceUpdate({ id: apId, changes: { variant: newVariant } }));
    }
  }
  dispatch(activeElementSet({ linkId }));
};

export default activeElementSlice.reducer;
